<template>
	<div class="display-flex flex-wrap">
		<div class="flex-col-12 title-area">{{ title }}</div>
		<div v-if="description" class="flex-col-12 description">
			<h3>{{ description }}</h3>
		</div>
		<div class="flex-col-12 input pt-1">
			<slot name="input" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'WizardInputFieldLayout',
	props: { title: { type: String, required: true }, description: { type: String } },
};
</script>

<style lang="scss" scoped>
.title-area {
	font-size: 18px;
	font-weight: 500;
	color: #303133;
}
.description h3 {
	color: var(--wizard-input-field-description-font-color);
}
</style>
